package com.example.event_management_system

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.transitions.SlideTransition
import coil3.ImageLoader
import coil3.compose.setSingletonImageLoaderFactory
import coil3.network.ktor3.KtorNetworkFetcherFactory
import com.example.event_management_system.di.appModule
import com.example.event_management_system.ui.screens.login.LoginScreen
import com.example.event_management_system.ui.theme.AppTheme
import org.koin.compose.KoinApplication

@Composable
fun App() {
    setSingletonImageLoaderFactory { context ->
        ImageLoader.Builder(context)
            .components {
                add(KtorNetworkFetcherFactory())
            }
            .build()
    }
    KoinApplication(application = {
        modules(appModule)
    }) {
        AppTheme {
            Navigator(LoginScreen()) { navigator ->
                SlideTransition(navigator)
            }
        }
    }
}